'use client';

import { FullScreenLoader } from '@terra/ui-design-system';
import { useResolvedAuthProviderType } from '../../../hooks/useResolvedAuthProviderType';
import { DescopeAuthProvider } from './providers/DescopeAuthProvider';
import { OpenIdAuthProvider } from './providers/OpenIdAuthProvider';
import { LocalAuthProvider } from './providers/LocalAuthProvider';
import type { AuthProviderProps } from './types';

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const providerType = useResolvedAuthProviderType();

  if (!providerType) {
    return <FullScreenLoader />;
  }

  if (providerType === 'openid') {
    return <OpenIdAuthProvider>{children}</OpenIdAuthProvider>;
  }

  if (providerType === 'local') {
    return <LocalAuthProvider>{children}</LocalAuthProvider>;
  }

  return <DescopeAuthProvider>{children}</DescopeAuthProvider>;
};
